import React from 'react';
import Logo from "../../Components/Logo";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";

import {TbArrowBadgeLeft} from "react-icons/tb";


export default function Register() {

    const [buttonStatus, setButtonStatus] = React.useState( "");
    const [buttonText, setButtonText] = React.useState('ادامه');
    const [loading, setLoading] = React.useState('d-none');
    const [surname, setSurname] = React.useState("");

    React.useEffect(() => {

    }, []);

    const onNameChange = (event) => {
        setSurname(event.target.value)
    }

    const onButtonClick =  () => {
        setButtonText("");
        setLoading("d-inline-block");
        setButtonStatus("disabled");


        const request = {
            surname
        }
        API.updateProfile( request )
            .then((response) => {
                toast.success(response.message);
                window.localStorage.removeItem("needRegistration");

                setTimeout (() => {
                    let cartItems = JSON.parse(window.localStorage.getItem("cart"));
                   cartItems ? window.location.replace('/cart') : window.location.replace('/home');
                },1500)

            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setButtonText("ادامه");
                setLoading("d-none")
                setButtonStatus('')

            });
    }


    return (
        <React.Fragment>

            <Toast />

            <section className="container-fluid rtl mt-3 max-w-lg">
                <div className="row paper-cart">
                    <div className="col-12">
                        <Logo size={110} />
                    </div>
                    <div className="col-12 mt-4 text-end text-black fw-bold pe-4 mb-3  ">
                       ثبت نام

                    </div>
                    <div className="col-12 my-2 text-end text-small-2 text-muted pe-4  ">
                        به نظر می رسد تا کنون از اپلیکیشن ما استفاده نکرده اید :)
                        <br/>
                        لطفا برای ادامه کار نام خانوادگی خود را وارد کنید

                    </div>

                    <div className="col-12 mt-3 ">
                        <div className="form-floating mb-3">
                            <input type="text"
                                   className="form-control text-center text-big-2"
                                   id="floatingInput"
                                   placeholder="otp"
                                   value={surname}
                                   onChange={onNameChange}
                            />
                            <label htmlFor="floatingInput" className="right-0">
                              نام خانوادگی
                            </label>
                        </div>
                    </div>
                    <div className="col-12 mt-3 ">
                        <div className="form-floating mb-3">
                            <input type="text"
                                   className="form-control text-center text-small-1"
                                   id="floatingInput"
                                   placeholder="otp"
                                   value="خراسان رضوی"
                                   readOnly
                                   disabled
                            />
                            <label htmlFor="floatingInput" className="right-0">
                           استان
                            </label>
                        </div>
                    </div>
                    <div className="col-12 mt-3 "
                         onClick={ () => toast.info('در حال حاضر خدمات فقط در شهر مشهد ارائه می شود')}
                    >
                        <div className="form-floating mb-3">
                            <input type="text"
                                   className="form-control text-center text-small-1"
                                   id="floatingInput"
                                   placeholder="otp"
                                   value="مشهد"
                                   readOnly
                                   disabled
                            />
                            <label htmlFor="floatingInput" className="right-0">
                           شهر
                            </label>
                        </div>
                    </div>



                </div>

                <div className="row">
                    <div className="col-12 p-2 fixed-bottom max-w-lg">

                        <button
                            className="btn btn-success bg-secondary-color text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                            onClick={onButtonClick}
                            disabled={buttonStatus}
                        >
                            {buttonText}
                            <span className="badge  p-2 float-start">
<TbArrowBadgeLeft className='text-big-3' />
                    </span>
                            <span  className={"spinner-grow spinner-grow-sm " + loading} role="status"
                                   aria-hidden="true">

                            </span>
                        </button>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
